import { useContext } from 'react';
import { Icon, IconsMap } from '@nx-frontend/shared/ui/icon';
import { PaywallContext } from './paywall-context';

interface PaywallCloseButtonProps {
  onClick: () => void;
}

export const PaywallCloseButton = ({ onClick }: PaywallCloseButtonProps) => {
  const { mode } = useContext(PaywallContext);

  if (mode !== 'upgrade') {
    return null;
  }

  return (
    <button className="absolute right-4 top-4" onClick={onClick}>
      <Icon icon={IconsMap.CLOSE} className="w-5 text-black text-opacity-60" />
    </button>
  );
};
